import type { FeatureFlag } from "@/types/feature-flags"

// Mock feature flags data that mimics the structure from the backend
export const mockFeatureFlags: FeatureFlag[] = [
  {
    GroupName: "FeatureConfiguration",
    Data: {
      Flag: true,
      FeatureName: "attributionsTab",
      FeatureDescription: "When active attributions tab will show on WO screen",
    },
    id: "205c877f-992b-4962-b58b-8d6043ee0b16",
    DocumentType: "FeatureFlag",
    IsDeleted: false,
    PartitionKey: "Procom-FeatureFlag-qa",
    EnvironmentName: "qa",
    TenantName: "Procom",
    CreatedByProfileId: 1,
    CreatedDateTime: "2023-04-10T14:11:14.568+00:00",
    LastModifiedByProfileId: 39,
    LastModifiedDateTime: "2025-05-07T22:44:10.4751402+00:00",
  },
  {
    GroupName: "FeatureConfiguration",
    Data: {
      Flag: false,
      FeatureName: "darkMode",
      FeatureDescription: "Enables dark mode in the application",
    },
    id: "305c877f-992b-4962-b58b-8d6043ee0b17",
    DocumentType: "FeatureFlag",
    IsDeleted: false,
    PartitionKey: "Procom-FeatureFlag-qa",
    EnvironmentName: "qa",
    TenantName: "Procom",
    CreatedByProfileId: 1,
    CreatedDateTime: "2023-04-10T14:11:14.568+00:00",
    LastModifiedByProfileId: 39,
    LastModifiedDateTime: "2025-05-07T22:44:10.4751402+00:00",
  },
  {
    GroupName: "FeatureConfiguration",
    Data: {
      Flag: true,
      FeatureName: "advancedSearch",
      FeatureDescription: "Enables advanced search functionality",
    },
    id: "405c877f-992b-4962-b58b-8d6043ee0b18",
    DocumentType: "FeatureFlag",
    IsDeleted: false,
    PartitionKey: "Procom-FeatureFlag-qa",
    EnvironmentName: "qa",
    TenantName: "Procom",
    CreatedByProfileId: 1,
    CreatedDateTime: "2023-04-10T14:11:14.568+00:00",
    LastModifiedByProfileId: 39,
    LastModifiedDateTime: "2025-05-07T22:44:10.4751402+00:00",
  },
]
